import { Stack } from "@mui/material";

export default function Actions({ children, ...props }) {
  return (
    <Stack direction="row" spacing={2} {...props}>
      {children}
    </Stack>
  );
}
